module.exports = __webpack_public_path__ + "static/media/19.96faed7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairback/19.png
// module id = 656
// module chunks = 0